/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiHitData } from '../api-models';
// @ts-ignore
import { AssignEmployeeToOpenShiftRequest } from '../api-models';
// @ts-ignore
import { AvailableEmployeesOrderBy } from '../api-models';
// @ts-ignore
import { BaseMenuDto } from '../api-models';
// @ts-ignore
import { CreateOpenShiftRequest } from '../api-models';
// @ts-ignore
import { DeleteUserRequest } from '../api-models';
// @ts-ignore
import { EmployeeCreateRequest } from '../api-models';
// @ts-ignore
import { EmployeeModel } from '../api-models';
// @ts-ignore
import { EmployeeModelV2 } from '../api-models';
// @ts-ignore
import { EmployeeRecordV3 } from '../api-models';
// @ts-ignore
import { EmployeeRole } from '../api-models';
// @ts-ignore
import { FacilityRoleResponse } from '../api-models';
// @ts-ignore
import { FacilitySearchUserRequest } from '../api-models';
// @ts-ignore
import { GetEncryptedLicenseResponse } from '../api-models';
// @ts-ignore
import { GetOpenShiftsMultipleResponseV3 } from '../api-models';
// @ts-ignore
import { GetOpenShiftsResponse } from '../api-models';
// @ts-ignore
import { IsUpdateAllowedResponse } from '../api-models';
// @ts-ignore
import { KeyValuePairOfStringAndString } from '../api-models';
// @ts-ignore
import { License } from '../api-models';
// @ts-ignore
import { LockUserAccountRequest } from '../api-models';
// @ts-ignore
import { MarkOpenshiftEmployeePendingRequest } from '../api-models';
// @ts-ignore
import { MetricsRequest } from '../api-models';
// @ts-ignore
import { OffboardEmployeesRequest } from '../api-models';
// @ts-ignore
import { OnboardEmployeesRequest } from '../api-models';
// @ts-ignore
import { OnboardingResponse } from '../api-models';
// @ts-ignore
import { OpenShiftPendingAssignmentsResponse } from '../api-models';
// @ts-ignore
import { OpenShiftUpdateResponse } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { ResendOtpAllUnregisteredResponse } from '../api-models';
// @ts-ignore
import { ResendOtpFromFacilityPortalRequest } from '../api-models';
// @ts-ignore
import { Response } from '../api-models';
// @ts-ignore
import { SearchUserRequest } from '../api-models';
// @ts-ignore
import { SearchUserResponseOfEmployeeModel } from '../api-models';
// @ts-ignore
import { SearchUserResponseOfFacilityEmployeeModel } from '../api-models';
// @ts-ignore
import { SyncEmployeeResponse } from '../api-models';
// @ts-ignore
import { TaConfigurationManager } from '../api-models';
// @ts-ignore
import { TimeCardResponse } from '../api-models';
// @ts-ignore
import { TupleOfBooleanAndCreateOpenShiftResponse } from '../api-models';
// @ts-ignore
import { UpdateOpenShiftEmployeeRequest } from '../api-models';
/**
 * FacilityApi - axios parameter creator
 * @export
 */
export const FacilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityCacheKeyDelete: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('facilityCacheKeyDelete', 'key', key)
            const localVarPath = `/facility/cache/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityCacheKeyGet: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('facilityCacheKeyGet', 'key', key)
            const localVarPath = `/facility/cache/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityConfigFacilityIdKeyGet: async (key: string, facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('facilityConfigFacilityIdKeyGet', 'key', key)
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('facilityConfigFacilityIdKeyGet', 'facilityId', facilityId)
            const localVarPath = `/facility/config/{facilityId}/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityConfigurationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteUserRequest} [deleteUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityEmployeeDelete: async (deleteUserRequest?: DeleteUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the facility license as an encrypted string.
         * @param {string} facilityId The facilityId to get the license for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityEncryptedLicenseFacilityIdGet: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('facilityEncryptedLicenseFacilityIdGet', 'facilityId', facilityId)
            const localVarPath = `/facility/encrypted-license/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 2 purposes:     1. Initial desktop user verification: Confirms a facility user\'s phone number and if applicable adds them to Saasdb and sends an OTP     2. start flow for desktop user reset password
         * @param {string} facilityId The unique identifier of the facility.
         * @param {string} [body] Employee phone number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityFacilityIdSendDesktopUserRegistrationPost: async (facilityId: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('facilityFacilityIdSendDesktopUserRegistrationPost', 'facilityId', facilityId)
            const localVarPath = `/facility/{facilityId}/send-desktop-user-registration`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [newPhoneNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityIsPhoneNumberUpdateAllowedForIdGet: async (id: number, newPhoneNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('facilityIsPhoneNumberUpdateAllowedForIdGet', 'id', id)
            const localVarPath = `/facility/is-phone-number-update-allowed-for/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (newPhoneNumber !== undefined) {
                localVarQueryParameter['newPhoneNumber'] = newPhoneNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {string} phoneNumber 
         * @param {number} [employeeIdToExclude] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet: async (facilityId: string, phoneNumber: string, employeeIdToExclude?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet', 'facilityId', facilityId)
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet', 'phoneNumber', phoneNumber)
            const localVarPath = `/facility/is-phone-number-used/{facilityId}/{phoneNumber}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"phoneNumber"}}`, encodeURIComponent(String(phoneNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeIdToExclude !== undefined) {
                localVarQueryParameter['employeeIdToExclude'] = employeeIdToExclude;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get facility license as decrypted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityLicenseGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/license`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityLockUserAccountPut: async (lockUserAccountRequest?: LockUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/lockUserAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} employeeIds 
         * @param {EmployeeRole} [role] 
         * @param {boolean} [isRegistered] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityLookupEmployeesGet: async (employeeIds: Array<number>, role?: EmployeeRole, isRegistered?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeIds' is not null or undefined
            assertParamExists('facilityLookupEmployeesGet', 'employeeIds', employeeIds)
            const localVarPath = `/facility/lookup-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeIds) {
                localVarQueryParameter['employeeIds'] = employeeIds;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (isRegistered !== undefined) {
                localVarQueryParameter['isRegistered'] = isRegistered;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityLookupEmployeesPost: async (requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/lookup-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * - Manager-bucket token (FacilityManager, Admin, Support, System): the facility\'s configured menu,    plus a `Web Punch` item (`/web-punch`) when the caller\'s own profile may web punch. Items that    require a Roles Management permission (SPD-5627) are left out unless the caller holds it;    Admin, Support and System see them all.  - Any other token, which is what a Mobile profile holds: only the `Web Punch` item when the    profile may web punch, otherwise an empty array. A 403 only while web punching is not released.
         * @summary The left menu for the signed-in caller.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityMenuGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOffboardEmployeePost: async (employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/offboard-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OffboardEmployeesRequest} [offboardEmployeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOffboardEmployeesPost: async (offboardEmployeesRequest?: OffboardEmployeesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/offboard-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offboardEmployeesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOnboardEmployeePost: async (employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/onboard-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OnboardEmployeesRequest} [onboardEmployeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOnboardEmployeesPost: async (onboardEmployeesRequest?: OnboardEmployeesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/onboard-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardEmployeesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all future openshifts for all employees of a facility.  It uses Facility Connection String from Middleware and gets data only from facility database  of a particular facility only.
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftGet: async (version?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/openshift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Consumed from TA app, when we click on done button at the bottom of webview window of openshifts, it assigns all pending openshift assignments
         * @param {string} openShiftId 
         * @param {AssignEmployeeToOpenShiftRequest} [assignEmployeeToOpenShiftRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftOpenShiftIdAssignPatch: async (openShiftId: string, assignEmployeeToOpenShiftRequest?: AssignEmployeeToOpenShiftRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openShiftId' is not null or undefined
            assertParamExists('facilityOpenshiftOpenShiftIdAssignPatch', 'openShiftId', openShiftId)
            const localVarPath = `/facility/openshift/{openShiftId}/assign`
                .replace(`{${"openShiftId"}}`, encodeURIComponent(String(openShiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignEmployeeToOpenShiftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Used by postman just to force interest by a particular user for the purpose of diagnostics
         * @param {string} openShiftId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost: async (openShiftId: string, employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openShiftId' is not null or undefined
            assertParamExists('facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost', 'openShiftId', openShiftId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost', 'employeeId', employeeId)
            const localVarPath = `/facility/openshift/{openShiftId}/interested/{employeeId}`
                .replace(`{${"openShiftId"}}`, encodeURIComponent(String(openShiftId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the status of association of an employee to an openshift   0 - Notify  1 - Show Interest  2 - Mark Pending  3 - Assign  4 - Dismiss
         * @param {string} openShiftId 
         * @param {UpdateOpenShiftEmployeeRequest} [updateOpenShiftEmployeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftOpenShiftIdPatch: async (openShiftId: string, updateOpenShiftEmployeeRequest?: UpdateOpenShiftEmployeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openShiftId' is not null or undefined
            assertParamExists('facilityOpenshiftOpenShiftIdPatch', 'openShiftId', openShiftId)
            const localVarPath = `/facility/openshift/{openShiftId}`
                .replace(`{${"openShiftId"}}`, encodeURIComponent(String(openShiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOpenShiftEmployeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Used from facility portal. When we click on assign button against any employee, it makes it pending.
         * @param {string} openShiftId 
         * @param {MarkOpenshiftEmployeePendingRequest} [markOpenshiftEmployeePendingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftOpenShiftIdPendingPut: async (openShiftId: string, markOpenshiftEmployeePendingRequest?: MarkOpenshiftEmployeePendingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openShiftId' is not null or undefined
            assertParamExists('facilityOpenshiftOpenShiftIdPendingPut', 'openShiftId', openShiftId)
            const localVarPath = `/facility/openshift/{openShiftId}/pending`
                .replace(`{${"openShiftId"}}`, encodeURIComponent(String(openShiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markOpenshiftEmployeePendingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Consumed from TA app, when we click on done button below the web view of openshifts, it retrieves all pending   openshifts to mark them as assigned, assignment is done in a different API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftPendingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/openshift/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obsolete: Moved to Openshifts controller
         * @param {CreateOpenShiftRequest} [createOpenShiftRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        facilityOpenshiftPost: async (createOpenShiftRequest?: CreateOpenShiftRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/openshift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOpenShiftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityRandomPasswordPost: async (lockUserAccountRequest?: LockUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/random-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MetricsRequest} [metricsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityRequestCountPost: async (metricsRequest?: MetricsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/request-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metricsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityResendOtpAllUnregisteredPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/resend-otp-all-unregistered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResendOtpFromFacilityPortalRequest} [resendOtpFromFacilityPortalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityResendOtpPut: async (resendOtpFromFacilityPortalRequest?: ResendOtpFromFacilityPortalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/resend-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendOtpFromFacilityPortalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityRolesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FacilitySearchUserRequest} [facilitySearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitySearchFacilityEmployeesPost: async (facilitySearchUserRequest?: FacilitySearchUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/search-facility-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitySearchUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchUserRequest} [searchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitySearchUsersPost: async (searchUserRequest?: SearchUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/search-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint takes approximately 1 full second minimum to return for each call. Keep this in mind  if making multiple sequential calls, as the delays can accumulate.
         * @summary Sends a mobile app invite text to the phone number on record for the provided employee.
         * @param {number} pkEmployeeId The PkEmployeeId of the employee to send a text to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitySendMobileAppInvitePkEmployeeIdPost: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('facilitySendMobileAppInvitePkEmployeeIdPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/facility/send-mobile-app-invite/{pkEmployeeId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Syncs the provided employee to the SaaS. New employees should be synced to enable them to register and  existing employees should be synced to update information that may have changed (e.g., cell phone number, role, status).
         * @param {number} [version] The version of this endpoint to invoke. Versions 2 and up do not send a mobile app invite text to new mobile employees.  This parameter allows for backward compatibility with old versions of legacy that expect a mobile invite  text to be sent to new mobile employees when syncing. Updated legacy versions (and other clients) should  make sure to set the version to &#x60;2&#x60; so that auto-sync does not send texts, and should instead manually  invoke the &#x60;/send-mobile-app-invite endpoint&#x60; to request texts directly.
         * @param {EmployeeCreateRequest} [employeeCreateRequest] The PkEmployeeId of the employee to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitySyncEmployeePut: async (version?: number, employeeCreateRequest?: EmployeeCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/sync-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityTimecardEmployeeIdGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('facilityTimecardEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/facility/timecard/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityUnlockUserAccountPut: async (lockUserAccountRequest?: LockUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/unlockUserAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityV2LookupEmployeesPost: async (requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/v2/lookup-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [openshiftId] 
         * @param {AvailableEmployeesOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityV2OpenshiftEmployeesGet: async (openshiftId?: string, orderBy?: AvailableEmployeesOrderBy, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/v2/openshift-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (openshiftId !== undefined) {
                localVarQueryParameter['openshiftId'] = openshiftId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<number>} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionId] 
         * @param {Array<number>} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityV2OpenshiftGet: async (startDate: string, endDate: string, departmentId?: Array<number>, facilityId?: number, positionId?: Array<number>, unitId?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('facilityV2OpenshiftGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('facilityV2OpenshiftGet', 'endDate', endDate)
            const localVarPath = `/facility/v2/openshift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionId) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (unitId) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {string} [payDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityWorkSchedulesEmployeeIdGet: async (employeeId: number, payDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('facilityWorkSchedulesEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/facility/work-schedules/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {string} [payDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityWorkSchedulesInRangeEmployeeIdGet: async (employeeId: number, payDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('facilityWorkSchedulesInRangeEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/facility/work-schedules-in-range/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacilityApi - functional programming interface
 * @export
 */
export const FacilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacilityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityCacheKeyDelete(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityCacheKeyDelete(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityCacheKeyGet(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityCacheKeyGet(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityConfigFacilityIdKeyGet(key: string, facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeyValuePairOfStringAndString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityConfigFacilityIdKeyGet(key, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityConfigurationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaConfigurationManager>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityConfigurationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteUserRequest} [deleteUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityEmployeeDelete(deleteUserRequest?: DeleteUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityEmployeeDelete(deleteUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the facility license as an encrypted string.
         * @param {string} facilityId The facilityId to get the license for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityEncryptedLicenseFacilityIdGet(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEncryptedLicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityEncryptedLicenseFacilityIdGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 2 purposes:     1. Initial desktop user verification: Confirms a facility user\'s phone number and if applicable adds them to Saasdb and sends an OTP     2. start flow for desktop user reset password
         * @param {string} facilityId The unique identifier of the facility.
         * @param {string} [body] Employee phone number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityFacilityIdSendDesktopUserRegistrationPost(facilityId: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityFacilityIdSendDesktopUserRegistrationPost(facilityId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [newPhoneNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityIsPhoneNumberUpdateAllowedForIdGet(id: number, newPhoneNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsUpdateAllowedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityIsPhoneNumberUpdateAllowedForIdGet(id, newPhoneNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {string} phoneNumber 
         * @param {number} [employeeIdToExclude] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet(facilityId: string, phoneNumber: string, employeeIdToExclude?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet(facilityId, phoneNumber, employeeIdToExclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get facility license as decrypted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityLicenseGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<License>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityLicenseGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityLockUserAccountPut(lockUserAccountRequest?: LockUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityLockUserAccountPut(lockUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} employeeIds 
         * @param {EmployeeRole} [role] 
         * @param {boolean} [isRegistered] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityLookupEmployeesGet(employeeIds: Array<number>, role?: EmployeeRole, isRegistered?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityLookupEmployeesGet(employeeIds, role, isRegistered, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityLookupEmployeesPost(requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityLookupEmployeesPost(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * - Manager-bucket token (FacilityManager, Admin, Support, System): the facility\'s configured menu,    plus a `Web Punch` item (`/web-punch`) when the caller\'s own profile may web punch. Items that    require a Roles Management permission (SPD-5627) are left out unless the caller holds it;    Admin, Support and System see them all.  - Any other token, which is what a Mobile profile holds: only the `Web Punch` item when the    profile may web punch, otherwise an empty array. A 403 only while web punching is not released.
         * @summary The left menu for the signed-in caller.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityMenuGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseMenuDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityMenuGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOffboardEmployeePost(employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOffboardEmployeePost(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OffboardEmployeesRequest} [offboardEmployeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOffboardEmployeesPost(offboardEmployeesRequest?: OffboardEmployeesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOffboardEmployeesPost(offboardEmployeesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOnboardEmployeePost(employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOnboardEmployeePost(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OnboardEmployeesRequest} [onboardEmployeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOnboardEmployeesPost(onboardEmployeesRequest?: OnboardEmployeesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOnboardEmployeesPost(onboardEmployeesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets all future openshifts for all employees of a facility.  It uses Facility Connection String from Middleware and gets data only from facility database  of a particular facility only.
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOpenshiftGet(version?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOpenShiftsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOpenshiftGet(version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Consumed from TA app, when we click on done button at the bottom of webview window of openshifts, it assigns all pending openshift assignments
         * @param {string} openShiftId 
         * @param {AssignEmployeeToOpenShiftRequest} [assignEmployeeToOpenShiftRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOpenshiftOpenShiftIdAssignPatch(openShiftId: string, assignEmployeeToOpenShiftRequest?: AssignEmployeeToOpenShiftRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenShiftUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOpenshiftOpenShiftIdAssignPatch(openShiftId, assignEmployeeToOpenShiftRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Used by postman just to force interest by a particular user for the purpose of diagnostics
         * @param {string} openShiftId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost(openShiftId: string, employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenShiftUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost(openShiftId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the status of association of an employee to an openshift   0 - Notify  1 - Show Interest  2 - Mark Pending  3 - Assign  4 - Dismiss
         * @param {string} openShiftId 
         * @param {UpdateOpenShiftEmployeeRequest} [updateOpenShiftEmployeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOpenshiftOpenShiftIdPatch(openShiftId: string, updateOpenShiftEmployeeRequest?: UpdateOpenShiftEmployeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenShiftUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOpenshiftOpenShiftIdPatch(openShiftId, updateOpenShiftEmployeeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Used from facility portal. When we click on assign button against any employee, it makes it pending.
         * @param {string} openShiftId 
         * @param {MarkOpenshiftEmployeePendingRequest} [markOpenshiftEmployeePendingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOpenshiftOpenShiftIdPendingPut(openShiftId: string, markOpenshiftEmployeePendingRequest?: MarkOpenshiftEmployeePendingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenShiftUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOpenshiftOpenShiftIdPendingPut(openShiftId, markOpenshiftEmployeePendingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Consumed from TA app, when we click on done button below the web view of openshifts, it retrieves all pending   openshifts to mark them as assigned, assignment is done in a different API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityOpenshiftPendingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenShiftPendingAssignmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOpenshiftPendingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obsolete: Moved to Openshifts controller
         * @param {CreateOpenShiftRequest} [createOpenShiftRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async facilityOpenshiftPost(createOpenShiftRequest?: CreateOpenShiftRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TupleOfBooleanAndCreateOpenShiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityOpenshiftPost(createOpenShiftRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityRandomPasswordPost(lockUserAccountRequest?: LockUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityRandomPasswordPost(lockUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MetricsRequest} [metricsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityRequestCountPost(metricsRequest?: MetricsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiHitData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityRequestCountPost(metricsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityResendOtpAllUnregisteredPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendOtpAllUnregisteredResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityResendOtpAllUnregisteredPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResendOtpFromFacilityPortalRequest} [resendOtpFromFacilityPortalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityResendOtpPut(resendOtpFromFacilityPortalRequest?: ResendOtpFromFacilityPortalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityResendOtpPut(resendOtpFromFacilityPortalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityRolesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FacilityRoleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityRolesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FacilitySearchUserRequest} [facilitySearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilitySearchFacilityEmployeesPost(facilitySearchUserRequest?: FacilitySearchUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchUserResponseOfFacilityEmployeeModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilitySearchFacilityEmployeesPost(facilitySearchUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchUserRequest} [searchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilitySearchUsersPost(searchUserRequest?: SearchUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUserResponseOfEmployeeModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilitySearchUsersPost(searchUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint takes approximately 1 full second minimum to return for each call. Keep this in mind  if making multiple sequential calls, as the delays can accumulate.
         * @summary Sends a mobile app invite text to the phone number on record for the provided employee.
         * @param {number} pkEmployeeId The PkEmployeeId of the employee to send a text to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilitySendMobileAppInvitePkEmployeeIdPost(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncEmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilitySendMobileAppInvitePkEmployeeIdPost(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Syncs the provided employee to the SaaS. New employees should be synced to enable them to register and  existing employees should be synced to update information that may have changed (e.g., cell phone number, role, status).
         * @param {number} [version] The version of this endpoint to invoke. Versions 2 and up do not send a mobile app invite text to new mobile employees.  This parameter allows for backward compatibility with old versions of legacy that expect a mobile invite  text to be sent to new mobile employees when syncing. Updated legacy versions (and other clients) should  make sure to set the version to &#x60;2&#x60; so that auto-sync does not send texts, and should instead manually  invoke the &#x60;/send-mobile-app-invite endpoint&#x60; to request texts directly.
         * @param {EmployeeCreateRequest} [employeeCreateRequest] The PkEmployeeId of the employee to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilitySyncEmployeePut(version?: number, employeeCreateRequest?: EmployeeCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncEmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilitySyncEmployeePut(version, employeeCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityTimecardEmployeeIdGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityTimecardEmployeeIdGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityUnlockUserAccountPut(lockUserAccountRequest?: LockUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityUnlockUserAccountPut(lockUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityV2LookupEmployeesPost(requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeModelV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityV2LookupEmployeesPost(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [openshiftId] 
         * @param {AvailableEmployeesOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityV2OpenshiftEmployeesGet(openshiftId?: string, orderBy?: AvailableEmployeesOrderBy, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeRecordV3>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityV2OpenshiftEmployeesGet(openshiftId, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Array<number>} [departmentId] 
         * @param {number} [facilityId] 
         * @param {Array<number>} [positionId] 
         * @param {Array<number>} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityV2OpenshiftGet(startDate: string, endDate: string, departmentId?: Array<number>, facilityId?: number, positionId?: Array<number>, unitId?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOpenShiftsMultipleResponseV3>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityV2OpenshiftGet(startDate, endDate, departmentId, facilityId, positionId, unitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {string} [payDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityWorkSchedulesEmployeeIdGet(employeeId: number, payDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityWorkSchedulesEmployeeIdGet(employeeId, payDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {string} [payDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityWorkSchedulesInRangeEmployeeIdGet(employeeId: number, payDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityWorkSchedulesInRangeEmployeeIdGet(employeeId, payDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FacilityApi - factory interface
 * @export
 */
export const FacilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacilityApiFp(configuration)
    return {
        /**
         * 
         * @param {FacilityApiFacilityCacheKeyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityCacheKeyDelete(requestParameters: FacilityApiFacilityCacheKeyDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityCacheKeyDelete(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityCacheKeyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityCacheKeyGet(requestParameters: FacilityApiFacilityCacheKeyGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityCacheKeyGet(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityConfigFacilityIdKeyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityConfigFacilityIdKeyGet(requestParameters: FacilityApiFacilityConfigFacilityIdKeyGetRequest, options?: AxiosRequestConfig): AxiosPromise<KeyValuePairOfStringAndString> {
            return localVarFp.facilityConfigFacilityIdKeyGet(requestParameters.key, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityConfigurationGet(options?: AxiosRequestConfig): AxiosPromise<TaConfigurationManager> {
            return localVarFp.facilityConfigurationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityEmployeeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityEmployeeDelete(requestParameters: FacilityApiFacilityEmployeeDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityEmployeeDelete(requestParameters.deleteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the facility license as an encrypted string.
         * @param {FacilityApiFacilityEncryptedLicenseFacilityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityEncryptedLicenseFacilityIdGet(requestParameters: FacilityApiFacilityEncryptedLicenseFacilityIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetEncryptedLicenseResponse> {
            return localVarFp.facilityEncryptedLicenseFacilityIdGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 2 purposes:     1. Initial desktop user verification: Confirms a facility user\'s phone number and if applicable adds them to Saasdb and sends an OTP     2. start flow for desktop user reset password
         * @param {FacilityApiFacilityFacilityIdSendDesktopUserRegistrationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityFacilityIdSendDesktopUserRegistrationPost(requestParameters: FacilityApiFacilityFacilityIdSendDesktopUserRegistrationPostRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityFacilityIdSendDesktopUserRegistrationPost(requestParameters.facilityId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityIsPhoneNumberUpdateAllowedForIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityIsPhoneNumberUpdateAllowedForIdGet(requestParameters: FacilityApiFacilityIsPhoneNumberUpdateAllowedForIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<IsUpdateAllowedResponse> {
            return localVarFp.facilityIsPhoneNumberUpdateAllowedForIdGet(requestParameters.id, requestParameters.newPhoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityIsPhoneNumberUsedFacilityIdPhoneNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet(requestParameters: FacilityApiFacilityIsPhoneNumberUsedFacilityIdPhoneNumberGetRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet(requestParameters.facilityId, requestParameters.phoneNumber, requestParameters.employeeIdToExclude, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get facility license as decrypted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityLicenseGet(options?: AxiosRequestConfig): AxiosPromise<License> {
            return localVarFp.facilityLicenseGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityLockUserAccountPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityLockUserAccountPut(requestParameters: FacilityApiFacilityLockUserAccountPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityLockUserAccountPut(requestParameters.lockUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityLookupEmployeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityLookupEmployeesGet(requestParameters: FacilityApiFacilityLookupEmployeesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeModel>> {
            return localVarFp.facilityLookupEmployeesGet(requestParameters.employeeIds, requestParameters.role, requestParameters.isRegistered, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityLookupEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityLookupEmployeesPost(requestParameters: FacilityApiFacilityLookupEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeModel>> {
            return localVarFp.facilityLookupEmployeesPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * - Manager-bucket token (FacilityManager, Admin, Support, System): the facility\'s configured menu,    plus a `Web Punch` item (`/web-punch`) when the caller\'s own profile may web punch. Items that    require a Roles Management permission (SPD-5627) are left out unless the caller holds it;    Admin, Support and System see them all.  - Any other token, which is what a Mobile profile holds: only the `Web Punch` item when the    profile may web punch, otherwise an empty array. A 403 only while web punching is not released.
         * @summary The left menu for the signed-in caller.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityMenuGet(options?: AxiosRequestConfig): AxiosPromise<Array<BaseMenuDto>> {
            return localVarFp.facilityMenuGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityOffboardEmployeePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOffboardEmployeePost(requestParameters: FacilityApiFacilityOffboardEmployeePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityOffboardEmployeePost(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityOffboardEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOffboardEmployeesPost(requestParameters: FacilityApiFacilityOffboardEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OnboardingResponse> {
            return localVarFp.facilityOffboardEmployeesPost(requestParameters.offboardEmployeesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityOnboardEmployeePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOnboardEmployeePost(requestParameters: FacilityApiFacilityOnboardEmployeePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityOnboardEmployeePost(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityOnboardEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOnboardEmployeesPost(requestParameters: FacilityApiFacilityOnboardEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OnboardingResponse> {
            return localVarFp.facilityOnboardEmployeesPost(requestParameters.onboardEmployeesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all future openshifts for all employees of a facility.  It uses Facility Connection String from Middleware and gets data only from facility database  of a particular facility only.
         * @param {FacilityApiFacilityOpenshiftGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftGet(requestParameters: FacilityApiFacilityOpenshiftGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetOpenShiftsResponse> {
            return localVarFp.facilityOpenshiftGet(requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Consumed from TA app, when we click on done button at the bottom of webview window of openshifts, it assigns all pending openshift assignments
         * @param {FacilityApiFacilityOpenshiftOpenShiftIdAssignPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftOpenShiftIdAssignPatch(requestParameters: FacilityApiFacilityOpenshiftOpenShiftIdAssignPatchRequest, options?: AxiosRequestConfig): AxiosPromise<OpenShiftUpdateResponse> {
            return localVarFp.facilityOpenshiftOpenShiftIdAssignPatch(requestParameters.openShiftId, requestParameters.assignEmployeeToOpenShiftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Used by postman just to force interest by a particular user for the purpose of diagnostics
         * @param {FacilityApiFacilityOpenshiftOpenShiftIdInterestedEmployeeIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost(requestParameters: FacilityApiFacilityOpenshiftOpenShiftIdInterestedEmployeeIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<OpenShiftUpdateResponse> {
            return localVarFp.facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost(requestParameters.openShiftId, requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the status of association of an employee to an openshift   0 - Notify  1 - Show Interest  2 - Mark Pending  3 - Assign  4 - Dismiss
         * @param {FacilityApiFacilityOpenshiftOpenShiftIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftOpenShiftIdPatch(requestParameters: FacilityApiFacilityOpenshiftOpenShiftIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<OpenShiftUpdateResponse> {
            return localVarFp.facilityOpenshiftOpenShiftIdPatch(requestParameters.openShiftId, requestParameters.updateOpenShiftEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Used from facility portal. When we click on assign button against any employee, it makes it pending.
         * @param {FacilityApiFacilityOpenshiftOpenShiftIdPendingPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftOpenShiftIdPendingPut(requestParameters: FacilityApiFacilityOpenshiftOpenShiftIdPendingPutRequest, options?: AxiosRequestConfig): AxiosPromise<OpenShiftUpdateResponse> {
            return localVarFp.facilityOpenshiftOpenShiftIdPendingPut(requestParameters.openShiftId, requestParameters.markOpenshiftEmployeePendingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Consumed from TA app, when we click on done button below the web view of openshifts, it retrieves all pending   openshifts to mark them as assigned, assignment is done in a different API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityOpenshiftPendingGet(options?: AxiosRequestConfig): AxiosPromise<OpenShiftPendingAssignmentsResponse> {
            return localVarFp.facilityOpenshiftPendingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obsolete: Moved to Openshifts controller
         * @param {FacilityApiFacilityOpenshiftPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        facilityOpenshiftPost(requestParameters: FacilityApiFacilityOpenshiftPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<TupleOfBooleanAndCreateOpenShiftResponse> {
            return localVarFp.facilityOpenshiftPost(requestParameters.createOpenShiftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityRandomPasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityRandomPasswordPost(requestParameters: FacilityApiFacilityRandomPasswordPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityRandomPasswordPost(requestParameters.lockUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityRequestCountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityRequestCountPost(requestParameters: FacilityApiFacilityRequestCountPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ApiHitData>> {
            return localVarFp.facilityRequestCountPost(requestParameters.metricsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityResendOtpAllUnregisteredPost(options?: AxiosRequestConfig): AxiosPromise<ResendOtpAllUnregisteredResponse> {
            return localVarFp.facilityResendOtpAllUnregisteredPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityResendOtpPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityResendOtpPut(requestParameters: FacilityApiFacilityResendOtpPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityResendOtpPut(requestParameters.resendOtpFromFacilityPortalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityRolesGet(options?: AxiosRequestConfig): AxiosPromise<Array<FacilityRoleResponse>> {
            return localVarFp.facilityRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilitySearchFacilityEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitySearchFacilityEmployeesPost(requestParameters: FacilityApiFacilitySearchFacilityEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<SearchUserResponseOfFacilityEmployeeModel>> {
            return localVarFp.facilitySearchFacilityEmployeesPost(requestParameters.facilitySearchUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilitySearchUsersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitySearchUsersPost(requestParameters: FacilityApiFacilitySearchUsersPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SearchUserResponseOfEmployeeModel> {
            return localVarFp.facilitySearchUsersPost(requestParameters.searchUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint takes approximately 1 full second minimum to return for each call. Keep this in mind  if making multiple sequential calls, as the delays can accumulate.
         * @summary Sends a mobile app invite text to the phone number on record for the provided employee.
         * @param {FacilityApiFacilitySendMobileAppInvitePkEmployeeIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitySendMobileAppInvitePkEmployeeIdPost(requestParameters: FacilityApiFacilitySendMobileAppInvitePkEmployeeIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<SyncEmployeeResponse> {
            return localVarFp.facilitySendMobileAppInvitePkEmployeeIdPost(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Syncs the provided employee to the SaaS. New employees should be synced to enable them to register and  existing employees should be synced to update information that may have changed (e.g., cell phone number, role, status).
         * @param {FacilityApiFacilitySyncEmployeePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitySyncEmployeePut(requestParameters: FacilityApiFacilitySyncEmployeePutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SyncEmployeeResponse> {
            return localVarFp.facilitySyncEmployeePut(requestParameters.version, requestParameters.employeeCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityTimecardEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityTimecardEmployeeIdGet(requestParameters: FacilityApiFacilityTimecardEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<TimeCardResponse> {
            return localVarFp.facilityTimecardEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityUnlockUserAccountPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityUnlockUserAccountPut(requestParameters: FacilityApiFacilityUnlockUserAccountPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityUnlockUserAccountPut(requestParameters.lockUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityV2LookupEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityV2LookupEmployeesPost(requestParameters: FacilityApiFacilityV2LookupEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeModelV2>> {
            return localVarFp.facilityV2LookupEmployeesPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityV2OpenshiftEmployeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityV2OpenshiftEmployeesGet(requestParameters: FacilityApiFacilityV2OpenshiftEmployeesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeRecordV3>> {
            return localVarFp.facilityV2OpenshiftEmployeesGet(requestParameters.openshiftId, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityV2OpenshiftGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityV2OpenshiftGet(requestParameters: FacilityApiFacilityV2OpenshiftGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOpenShiftsMultipleResponseV3>> {
            return localVarFp.facilityV2OpenshiftGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, requestParameters.unitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityWorkSchedulesEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityWorkSchedulesEmployeeIdGet(requestParameters: FacilityApiFacilityWorkSchedulesEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityWorkSchedulesEmployeeIdGet(requestParameters.employeeId, requestParameters.payDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiFacilityWorkSchedulesInRangeEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityWorkSchedulesInRangeEmployeeIdGet(requestParameters: FacilityApiFacilityWorkSchedulesInRangeEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facilityWorkSchedulesInRangeEmployeeIdGet(requestParameters.employeeId, requestParameters.payDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for facilityCacheKeyDelete operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityCacheKeyDeleteRequest
 */
export interface FacilityApiFacilityCacheKeyDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityCacheKeyDelete
     */
    readonly key: string
}

/**
 * Request parameters for facilityCacheKeyGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityCacheKeyGetRequest
 */
export interface FacilityApiFacilityCacheKeyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityCacheKeyGet
     */
    readonly key: string
}

/**
 * Request parameters for facilityConfigFacilityIdKeyGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityConfigFacilityIdKeyGetRequest
 */
export interface FacilityApiFacilityConfigFacilityIdKeyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityConfigFacilityIdKeyGet
     */
    readonly key: string

    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityConfigFacilityIdKeyGet
     */
    readonly facilityId: string
}

/**
 * Request parameters for facilityEmployeeDelete operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityEmployeeDeleteRequest
 */
export interface FacilityApiFacilityEmployeeDeleteRequest {
    /**
     * 
     * @type {DeleteUserRequest}
     * @memberof FacilityApiFacilityEmployeeDelete
     */
    readonly deleteUserRequest?: DeleteUserRequest
}

/**
 * Request parameters for facilityEncryptedLicenseFacilityIdGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityEncryptedLicenseFacilityIdGetRequest
 */
export interface FacilityApiFacilityEncryptedLicenseFacilityIdGetRequest {
    /**
     * The facilityId to get the license for.
     * @type {string}
     * @memberof FacilityApiFacilityEncryptedLicenseFacilityIdGet
     */
    readonly facilityId: string
}

/**
 * Request parameters for facilityFacilityIdSendDesktopUserRegistrationPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityFacilityIdSendDesktopUserRegistrationPostRequest
 */
export interface FacilityApiFacilityFacilityIdSendDesktopUserRegistrationPostRequest {
    /**
     * The unique identifier of the facility.
     * @type {string}
     * @memberof FacilityApiFacilityFacilityIdSendDesktopUserRegistrationPost
     */
    readonly facilityId: string

    /**
     * Employee phone number.
     * @type {string}
     * @memberof FacilityApiFacilityFacilityIdSendDesktopUserRegistrationPost
     */
    readonly body?: string
}

/**
 * Request parameters for facilityIsPhoneNumberUpdateAllowedForIdGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityIsPhoneNumberUpdateAllowedForIdGetRequest
 */
export interface FacilityApiFacilityIsPhoneNumberUpdateAllowedForIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiFacilityIsPhoneNumberUpdateAllowedForIdGet
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityIsPhoneNumberUpdateAllowedForIdGet
     */
    readonly newPhoneNumber?: string
}

/**
 * Request parameters for facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityIsPhoneNumberUsedFacilityIdPhoneNumberGetRequest
 */
export interface FacilityApiFacilityIsPhoneNumberUsedFacilityIdPhoneNumberGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityIsPhoneNumberUsedFacilityIdPhoneNumberGet
     */
    readonly facilityId: string

    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityIsPhoneNumberUsedFacilityIdPhoneNumberGet
     */
    readonly phoneNumber: string

    /**
     * 
     * @type {number}
     * @memberof FacilityApiFacilityIsPhoneNumberUsedFacilityIdPhoneNumberGet
     */
    readonly employeeIdToExclude?: number
}

/**
 * Request parameters for facilityLockUserAccountPut operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityLockUserAccountPutRequest
 */
export interface FacilityApiFacilityLockUserAccountPutRequest {
    /**
     * 
     * @type {LockUserAccountRequest}
     * @memberof FacilityApiFacilityLockUserAccountPut
     */
    readonly lockUserAccountRequest?: LockUserAccountRequest
}

/**
 * Request parameters for facilityLookupEmployeesGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityLookupEmployeesGetRequest
 */
export interface FacilityApiFacilityLookupEmployeesGetRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof FacilityApiFacilityLookupEmployeesGet
     */
    readonly employeeIds: Array<number>

    /**
     * 
     * @type {EmployeeRole}
     * @memberof FacilityApiFacilityLookupEmployeesGet
     */
    readonly role?: EmployeeRole

    /**
     * 
     * @type {boolean}
     * @memberof FacilityApiFacilityLookupEmployeesGet
     */
    readonly isRegistered?: boolean
}

/**
 * Request parameters for facilityLookupEmployeesPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityLookupEmployeesPostRequest
 */
export interface FacilityApiFacilityLookupEmployeesPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof FacilityApiFacilityLookupEmployeesPost
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for facilityOffboardEmployeePost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOffboardEmployeePostRequest
 */
export interface FacilityApiFacilityOffboardEmployeePostRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiFacilityOffboardEmployeePost
     */
    readonly employeeId?: number
}

/**
 * Request parameters for facilityOffboardEmployeesPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOffboardEmployeesPostRequest
 */
export interface FacilityApiFacilityOffboardEmployeesPostRequest {
    /**
     * 
     * @type {OffboardEmployeesRequest}
     * @memberof FacilityApiFacilityOffboardEmployeesPost
     */
    readonly offboardEmployeesRequest?: OffboardEmployeesRequest
}

/**
 * Request parameters for facilityOnboardEmployeePost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOnboardEmployeePostRequest
 */
export interface FacilityApiFacilityOnboardEmployeePostRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiFacilityOnboardEmployeePost
     */
    readonly employeeId?: number
}

/**
 * Request parameters for facilityOnboardEmployeesPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOnboardEmployeesPostRequest
 */
export interface FacilityApiFacilityOnboardEmployeesPostRequest {
    /**
     * 
     * @type {OnboardEmployeesRequest}
     * @memberof FacilityApiFacilityOnboardEmployeesPost
     */
    readonly onboardEmployeesRequest?: OnboardEmployeesRequest
}

/**
 * Request parameters for facilityOpenshiftGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOpenshiftGetRequest
 */
export interface FacilityApiFacilityOpenshiftGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityOpenshiftGet
     */
    readonly version?: string
}

/**
 * Request parameters for facilityOpenshiftOpenShiftIdAssignPatch operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOpenshiftOpenShiftIdAssignPatchRequest
 */
export interface FacilityApiFacilityOpenshiftOpenShiftIdAssignPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityOpenshiftOpenShiftIdAssignPatch
     */
    readonly openShiftId: string

    /**
     * 
     * @type {AssignEmployeeToOpenShiftRequest}
     * @memberof FacilityApiFacilityOpenshiftOpenShiftIdAssignPatch
     */
    readonly assignEmployeeToOpenShiftRequest?: AssignEmployeeToOpenShiftRequest
}

/**
 * Request parameters for facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOpenshiftOpenShiftIdInterestedEmployeeIdPostRequest
 */
export interface FacilityApiFacilityOpenshiftOpenShiftIdInterestedEmployeeIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityOpenshiftOpenShiftIdInterestedEmployeeIdPost
     */
    readonly openShiftId: string

    /**
     * 
     * @type {number}
     * @memberof FacilityApiFacilityOpenshiftOpenShiftIdInterestedEmployeeIdPost
     */
    readonly employeeId: number
}

/**
 * Request parameters for facilityOpenshiftOpenShiftIdPatch operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOpenshiftOpenShiftIdPatchRequest
 */
export interface FacilityApiFacilityOpenshiftOpenShiftIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityOpenshiftOpenShiftIdPatch
     */
    readonly openShiftId: string

    /**
     * 
     * @type {UpdateOpenShiftEmployeeRequest}
     * @memberof FacilityApiFacilityOpenshiftOpenShiftIdPatch
     */
    readonly updateOpenShiftEmployeeRequest?: UpdateOpenShiftEmployeeRequest
}

/**
 * Request parameters for facilityOpenshiftOpenShiftIdPendingPut operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOpenshiftOpenShiftIdPendingPutRequest
 */
export interface FacilityApiFacilityOpenshiftOpenShiftIdPendingPutRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityOpenshiftOpenShiftIdPendingPut
     */
    readonly openShiftId: string

    /**
     * 
     * @type {MarkOpenshiftEmployeePendingRequest}
     * @memberof FacilityApiFacilityOpenshiftOpenShiftIdPendingPut
     */
    readonly markOpenshiftEmployeePendingRequest?: MarkOpenshiftEmployeePendingRequest
}

/**
 * Request parameters for facilityOpenshiftPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityOpenshiftPostRequest
 */
export interface FacilityApiFacilityOpenshiftPostRequest {
    /**
     * 
     * @type {CreateOpenShiftRequest}
     * @memberof FacilityApiFacilityOpenshiftPost
     */
    readonly createOpenShiftRequest?: CreateOpenShiftRequest
}

/**
 * Request parameters for facilityRandomPasswordPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityRandomPasswordPostRequest
 */
export interface FacilityApiFacilityRandomPasswordPostRequest {
    /**
     * 
     * @type {LockUserAccountRequest}
     * @memberof FacilityApiFacilityRandomPasswordPost
     */
    readonly lockUserAccountRequest?: LockUserAccountRequest
}

/**
 * Request parameters for facilityRequestCountPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityRequestCountPostRequest
 */
export interface FacilityApiFacilityRequestCountPostRequest {
    /**
     * 
     * @type {MetricsRequest}
     * @memberof FacilityApiFacilityRequestCountPost
     */
    readonly metricsRequest?: MetricsRequest
}

/**
 * Request parameters for facilityResendOtpPut operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityResendOtpPutRequest
 */
export interface FacilityApiFacilityResendOtpPutRequest {
    /**
     * 
     * @type {ResendOtpFromFacilityPortalRequest}
     * @memberof FacilityApiFacilityResendOtpPut
     */
    readonly resendOtpFromFacilityPortalRequest?: ResendOtpFromFacilityPortalRequest
}

/**
 * Request parameters for facilitySearchFacilityEmployeesPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilitySearchFacilityEmployeesPostRequest
 */
export interface FacilityApiFacilitySearchFacilityEmployeesPostRequest {
    /**
     * 
     * @type {FacilitySearchUserRequest}
     * @memberof FacilityApiFacilitySearchFacilityEmployeesPost
     */
    readonly facilitySearchUserRequest?: FacilitySearchUserRequest
}

/**
 * Request parameters for facilitySearchUsersPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilitySearchUsersPostRequest
 */
export interface FacilityApiFacilitySearchUsersPostRequest {
    /**
     * 
     * @type {SearchUserRequest}
     * @memberof FacilityApiFacilitySearchUsersPost
     */
    readonly searchUserRequest?: SearchUserRequest
}

/**
 * Request parameters for facilitySendMobileAppInvitePkEmployeeIdPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilitySendMobileAppInvitePkEmployeeIdPostRequest
 */
export interface FacilityApiFacilitySendMobileAppInvitePkEmployeeIdPostRequest {
    /**
     * The PkEmployeeId of the employee to send a text to
     * @type {number}
     * @memberof FacilityApiFacilitySendMobileAppInvitePkEmployeeIdPost
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for facilitySyncEmployeePut operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilitySyncEmployeePutRequest
 */
export interface FacilityApiFacilitySyncEmployeePutRequest {
    /**
     * The version of this endpoint to invoke. Versions 2 and up do not send a mobile app invite text to new mobile employees.  This parameter allows for backward compatibility with old versions of legacy that expect a mobile invite  text to be sent to new mobile employees when syncing. Updated legacy versions (and other clients) should  make sure to set the version to &#x60;2&#x60; so that auto-sync does not send texts, and should instead manually  invoke the &#x60;/send-mobile-app-invite endpoint&#x60; to request texts directly.
     * @type {number}
     * @memberof FacilityApiFacilitySyncEmployeePut
     */
    readonly version?: number

    /**
     * The PkEmployeeId of the employee to sync.
     * @type {EmployeeCreateRequest}
     * @memberof FacilityApiFacilitySyncEmployeePut
     */
    readonly employeeCreateRequest?: EmployeeCreateRequest
}

/**
 * Request parameters for facilityTimecardEmployeeIdGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityTimecardEmployeeIdGetRequest
 */
export interface FacilityApiFacilityTimecardEmployeeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiFacilityTimecardEmployeeIdGet
     */
    readonly employeeId: number
}

/**
 * Request parameters for facilityUnlockUserAccountPut operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityUnlockUserAccountPutRequest
 */
export interface FacilityApiFacilityUnlockUserAccountPutRequest {
    /**
     * 
     * @type {LockUserAccountRequest}
     * @memberof FacilityApiFacilityUnlockUserAccountPut
     */
    readonly lockUserAccountRequest?: LockUserAccountRequest
}

/**
 * Request parameters for facilityV2LookupEmployeesPost operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityV2LookupEmployeesPostRequest
 */
export interface FacilityApiFacilityV2LookupEmployeesPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof FacilityApiFacilityV2LookupEmployeesPost
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for facilityV2OpenshiftEmployeesGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityV2OpenshiftEmployeesGetRequest
 */
export interface FacilityApiFacilityV2OpenshiftEmployeesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityV2OpenshiftEmployeesGet
     */
    readonly openshiftId?: string

    /**
     * 
     * @type {AvailableEmployeesOrderBy}
     * @memberof FacilityApiFacilityV2OpenshiftEmployeesGet
     */
    readonly orderBy?: AvailableEmployeesOrderBy
}

/**
 * Request parameters for facilityV2OpenshiftGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityV2OpenshiftGetRequest
 */
export interface FacilityApiFacilityV2OpenshiftGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityV2OpenshiftGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityV2OpenshiftGet
     */
    readonly endDate: string

    /**
     * 
     * @type {Array<number>}
     * @memberof FacilityApiFacilityV2OpenshiftGet
     */
    readonly departmentId?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof FacilityApiFacilityV2OpenshiftGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FacilityApiFacilityV2OpenshiftGet
     */
    readonly positionId?: Array<number>

    /**
     * 
     * @type {Array<number>}
     * @memberof FacilityApiFacilityV2OpenshiftGet
     */
    readonly unitId?: Array<number>
}

/**
 * Request parameters for facilityWorkSchedulesEmployeeIdGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityWorkSchedulesEmployeeIdGetRequest
 */
export interface FacilityApiFacilityWorkSchedulesEmployeeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiFacilityWorkSchedulesEmployeeIdGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityWorkSchedulesEmployeeIdGet
     */
    readonly payDate?: string
}

/**
 * Request parameters for facilityWorkSchedulesInRangeEmployeeIdGet operation in FacilityApi.
 * @export
 * @interface FacilityApiFacilityWorkSchedulesInRangeEmployeeIdGetRequest
 */
export interface FacilityApiFacilityWorkSchedulesInRangeEmployeeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiFacilityWorkSchedulesInRangeEmployeeIdGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityWorkSchedulesInRangeEmployeeIdGet
     */
    readonly payDate?: string

    /**
     * 
     * @type {string}
     * @memberof FacilityApiFacilityWorkSchedulesInRangeEmployeeIdGet
     */
    readonly endDate?: string
}

/**
 * FacilityApi - object-oriented interface
 * @export
 * @class FacilityApi
 * @extends {BaseAPI}
 */
export class FacilityApi extends BaseAPI {
    /**
     * 
     * @param {FacilityApiFacilityCacheKeyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityCacheKeyDelete(requestParameters: FacilityApiFacilityCacheKeyDeleteRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityCacheKeyDelete(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityCacheKeyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityCacheKeyGet(requestParameters: FacilityApiFacilityCacheKeyGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityCacheKeyGet(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityConfigFacilityIdKeyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityConfigFacilityIdKeyGet(requestParameters: FacilityApiFacilityConfigFacilityIdKeyGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityConfigFacilityIdKeyGet(requestParameters.key, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityConfigurationGet(options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityConfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityEmployeeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityEmployeeDelete(requestParameters: FacilityApiFacilityEmployeeDeleteRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityEmployeeDelete(requestParameters.deleteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the facility license as an encrypted string.
     * @param {FacilityApiFacilityEncryptedLicenseFacilityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityEncryptedLicenseFacilityIdGet(requestParameters: FacilityApiFacilityEncryptedLicenseFacilityIdGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityEncryptedLicenseFacilityIdGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 2 purposes:     1. Initial desktop user verification: Confirms a facility user\'s phone number and if applicable adds them to Saasdb and sends an OTP     2. start flow for desktop user reset password
     * @param {FacilityApiFacilityFacilityIdSendDesktopUserRegistrationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityFacilityIdSendDesktopUserRegistrationPost(requestParameters: FacilityApiFacilityFacilityIdSendDesktopUserRegistrationPostRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityFacilityIdSendDesktopUserRegistrationPost(requestParameters.facilityId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityIsPhoneNumberUpdateAllowedForIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityIsPhoneNumberUpdateAllowedForIdGet(requestParameters: FacilityApiFacilityIsPhoneNumberUpdateAllowedForIdGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityIsPhoneNumberUpdateAllowedForIdGet(requestParameters.id, requestParameters.newPhoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityIsPhoneNumberUsedFacilityIdPhoneNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet(requestParameters: FacilityApiFacilityIsPhoneNumberUsedFacilityIdPhoneNumberGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityIsPhoneNumberUsedFacilityIdPhoneNumberGet(requestParameters.facilityId, requestParameters.phoneNumber, requestParameters.employeeIdToExclude, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get facility license as decrypted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityLicenseGet(options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityLicenseGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityLockUserAccountPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityLockUserAccountPut(requestParameters: FacilityApiFacilityLockUserAccountPutRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityLockUserAccountPut(requestParameters.lockUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityLookupEmployeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityLookupEmployeesGet(requestParameters: FacilityApiFacilityLookupEmployeesGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityLookupEmployeesGet(requestParameters.employeeIds, requestParameters.role, requestParameters.isRegistered, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityLookupEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityLookupEmployeesPost(requestParameters: FacilityApiFacilityLookupEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityLookupEmployeesPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * - Manager-bucket token (FacilityManager, Admin, Support, System): the facility\'s configured menu,    plus a `Web Punch` item (`/web-punch`) when the caller\'s own profile may web punch. Items that    require a Roles Management permission (SPD-5627) are left out unless the caller holds it;    Admin, Support and System see them all.  - Any other token, which is what a Mobile profile holds: only the `Web Punch` item when the    profile may web punch, otherwise an empty array. A 403 only while web punching is not released.
     * @summary The left menu for the signed-in caller.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityMenuGet(options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityMenuGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityOffboardEmployeePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOffboardEmployeePost(requestParameters: FacilityApiFacilityOffboardEmployeePostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOffboardEmployeePost(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityOffboardEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOffboardEmployeesPost(requestParameters: FacilityApiFacilityOffboardEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOffboardEmployeesPost(requestParameters.offboardEmployeesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityOnboardEmployeePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOnboardEmployeePost(requestParameters: FacilityApiFacilityOnboardEmployeePostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOnboardEmployeePost(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityOnboardEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOnboardEmployeesPost(requestParameters: FacilityApiFacilityOnboardEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOnboardEmployeesPost(requestParameters.onboardEmployeesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all future openshifts for all employees of a facility.  It uses Facility Connection String from Middleware and gets data only from facility database  of a particular facility only.
     * @param {FacilityApiFacilityOpenshiftGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOpenshiftGet(requestParameters: FacilityApiFacilityOpenshiftGetRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOpenshiftGet(requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Consumed from TA app, when we click on done button at the bottom of webview window of openshifts, it assigns all pending openshift assignments
     * @param {FacilityApiFacilityOpenshiftOpenShiftIdAssignPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOpenshiftOpenShiftIdAssignPatch(requestParameters: FacilityApiFacilityOpenshiftOpenShiftIdAssignPatchRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOpenshiftOpenShiftIdAssignPatch(requestParameters.openShiftId, requestParameters.assignEmployeeToOpenShiftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Used by postman just to force interest by a particular user for the purpose of diagnostics
     * @param {FacilityApiFacilityOpenshiftOpenShiftIdInterestedEmployeeIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost(requestParameters: FacilityApiFacilityOpenshiftOpenShiftIdInterestedEmployeeIdPostRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOpenshiftOpenShiftIdInterestedEmployeeIdPost(requestParameters.openShiftId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the status of association of an employee to an openshift   0 - Notify  1 - Show Interest  2 - Mark Pending  3 - Assign  4 - Dismiss
     * @param {FacilityApiFacilityOpenshiftOpenShiftIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOpenshiftOpenShiftIdPatch(requestParameters: FacilityApiFacilityOpenshiftOpenShiftIdPatchRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOpenshiftOpenShiftIdPatch(requestParameters.openShiftId, requestParameters.updateOpenShiftEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Used from facility portal. When we click on assign button against any employee, it makes it pending.
     * @param {FacilityApiFacilityOpenshiftOpenShiftIdPendingPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOpenshiftOpenShiftIdPendingPut(requestParameters: FacilityApiFacilityOpenshiftOpenShiftIdPendingPutRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOpenshiftOpenShiftIdPendingPut(requestParameters.openShiftId, requestParameters.markOpenshiftEmployeePendingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Consumed from TA app, when we click on done button below the web view of openshifts, it retrieves all pending   openshifts to mark them as assigned, assignment is done in a different API.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOpenshiftPendingGet(options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOpenshiftPendingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obsolete: Moved to Openshifts controller
     * @param {FacilityApiFacilityOpenshiftPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityOpenshiftPost(requestParameters: FacilityApiFacilityOpenshiftPostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityOpenshiftPost(requestParameters.createOpenShiftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityRandomPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityRandomPasswordPost(requestParameters: FacilityApiFacilityRandomPasswordPostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityRandomPasswordPost(requestParameters.lockUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityRequestCountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityRequestCountPost(requestParameters: FacilityApiFacilityRequestCountPostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityRequestCountPost(requestParameters.metricsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityResendOtpAllUnregisteredPost(options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityResendOtpAllUnregisteredPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityResendOtpPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityResendOtpPut(requestParameters: FacilityApiFacilityResendOtpPutRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityResendOtpPut(requestParameters.resendOtpFromFacilityPortalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityRolesGet(options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilitySearchFacilityEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilitySearchFacilityEmployeesPost(requestParameters: FacilityApiFacilitySearchFacilityEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilitySearchFacilityEmployeesPost(requestParameters.facilitySearchUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilitySearchUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilitySearchUsersPost(requestParameters: FacilityApiFacilitySearchUsersPostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilitySearchUsersPost(requestParameters.searchUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint takes approximately 1 full second minimum to return for each call. Keep this in mind  if making multiple sequential calls, as the delays can accumulate.
     * @summary Sends a mobile app invite text to the phone number on record for the provided employee.
     * @param {FacilityApiFacilitySendMobileAppInvitePkEmployeeIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilitySendMobileAppInvitePkEmployeeIdPost(requestParameters: FacilityApiFacilitySendMobileAppInvitePkEmployeeIdPostRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilitySendMobileAppInvitePkEmployeeIdPost(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Syncs the provided employee to the SaaS. New employees should be synced to enable them to register and  existing employees should be synced to update information that may have changed (e.g., cell phone number, role, status).
     * @param {FacilityApiFacilitySyncEmployeePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilitySyncEmployeePut(requestParameters: FacilityApiFacilitySyncEmployeePutRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilitySyncEmployeePut(requestParameters.version, requestParameters.employeeCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityTimecardEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityTimecardEmployeeIdGet(requestParameters: FacilityApiFacilityTimecardEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityTimecardEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityUnlockUserAccountPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityUnlockUserAccountPut(requestParameters: FacilityApiFacilityUnlockUserAccountPutRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityUnlockUserAccountPut(requestParameters.lockUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityV2LookupEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityV2LookupEmployeesPost(requestParameters: FacilityApiFacilityV2LookupEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityV2LookupEmployeesPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityV2OpenshiftEmployeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityV2OpenshiftEmployeesGet(requestParameters: FacilityApiFacilityV2OpenshiftEmployeesGetRequest = {}, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityV2OpenshiftEmployeesGet(requestParameters.openshiftId, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityV2OpenshiftGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityV2OpenshiftGet(requestParameters: FacilityApiFacilityV2OpenshiftGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityV2OpenshiftGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, requestParameters.unitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityWorkSchedulesEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityWorkSchedulesEmployeeIdGet(requestParameters: FacilityApiFacilityWorkSchedulesEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityWorkSchedulesEmployeeIdGet(requestParameters.employeeId, requestParameters.payDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiFacilityWorkSchedulesInRangeEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public facilityWorkSchedulesInRangeEmployeeIdGet(requestParameters: FacilityApiFacilityWorkSchedulesInRangeEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return FacilityApiFp(this.configuration).facilityWorkSchedulesInRangeEmployeeIdGet(requestParameters.employeeId, requestParameters.payDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}
